/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Spaces_Move_ToInputs */



/**
* | output |
* | --- |
* | "Move to {target}" |
*
* @param {Spaces_Move_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_move_to = /** @type {((inputs: Spaces_Move_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Move_ToInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verschieben nach ${i?.target}`)
	return /** @type {LocalizedString} */ (`Move to ${i?.target}`)
});